<template>
  <div>
    <div>
      <HeaderOfPage :titleOfPage="'أبيدوس '" :bgSrc="'single-place-page.jpg'" :theDiscription="'كل ما تحتاجة للسفر ... ستجد الأماكن، والاتجاهات، والمعلومات'"/>
    </div>
    <b-container class="pages-container">
      <section class="single-place-container">
        <article>
          <b-carousel
             id="carousel-fade"
             style="text-shadow: 0px 0px 2px #000"
             fade
             indicators
             img-width="1024"
             img-height="480"
           >
           <figure>
             <b-carousel-slide
               caption=""
               img-src="https://picsum.photos/1024/480/?image=10"
             >
           </b-carousel-slide>
             <figcaption>First slide</figcaption>
           </figure>
           <figure>
             <b-carousel-slide

               img-src="https://picsum.photos/1024/480/?image=12"
             >
          </b-carousel-slide>
             <figcaption>Second slide</figcaption>
           </figure>
           <figure>
             <b-carousel-slide
               img-src="https://picsum.photos/1024/480/?image=22"
             ></b-carousel-slide>
             <figcaption>Third slide</figcaption>
           </figure>
         </b-carousel>
         <div class="text-container">
           <h1>أبيدوس</h1>
           <h2>أبيدوس الجميلة </h2>
           <p>من أقدم المدن المصرية الموجودة بصعيد مصر وعلي وجهه التحديد بمركز البلينا بمحافظة سوهاج فتلك المدينة تعد الان من أهم وأعرق المواقع الاثرية في مصر وذلك لاحتوائها علي العديد من المعابد الاثرية والمدافن لملوك الاسر الفرعونية القديمة فمن أهم المعابد التي يظهر بها النقوش بارزة بشكل فني رائع والذي يدل علي براعة المصريين القدماء معبد أبيدوس الذي بناه اولا الملك سيتي الاول ووالده الملك رمسيس الثاني والذي اكتشف به اقدم مقابر في تاريخ مصر القديمة فتم بنائه داخل سور علي أن يتم حفظ مقبرة الاله اوزوريس بداخله وكان يحيط به في ايام الازدهار العديد من النباتات المزهرة داخل حديقة تحيط بالمعبد والتي كانت تعطي له منظر طبيعي شديد الجمال والجدير بالذكر ان جدران هذا المعبد رسمت عليه اهم الحروب التي خاضها الملك رمسيس الثاني واهم اعماله ايضا وانتصاراته في اسيا ذلك بالاضافة الي العديد من النقوش التذكارية الخاصة بشخصيته فتلك المدينة تعد الان من أهم وأعرق المواقع الاثرية في مصر التي تدل علي براعة المصريين القدماء ويجمع معظم علماء الاثار علي انها كانت عاصمة مصر الاولي بنهاية عصر ما قبل الاسر وكذلك اجمعوا ان بها العديد من المعابد فيصل عدد المعابد بها ال تسعة او عشر معابد ويتراوحوا من الاسرة الاولي حتي الاسرة الي 26 </p>
         </div>
         <div class="social-media-container">
           <social-sharing :url="'http://localhost:8080/#/blog/' + 'routename'"
                                title="نصائح تفيدك اذا كنت من هواة تسلق الجبال"
                                description=""
                                quote=""
                                hashtags="نصائح_حول_السفر"
                                twitter-user=""
                                inline-template>
            <div>
                <network network="email" class="email">
                    <i class="far fa-envelope"></i>

                </network>

                <network network="facebook" class="facebook">
                  <i class="fab fa-facebook-square"></i>
                </network>

                <network network="linkedin" class="linkedin">
                  <i class="fab fa-linkedin"></i>
                </network>

                <network network="pinterest" class="pinterest">
                  <i class="fab fa-pinterest-square"></i>
                </network>

                <network network="sms">
                  <i class="fas fa-sms"></i>
                </network>

                <network network="twitter" class="twitter">
                  <i class="fab fa-twitter-square"></i>
                </network>
                <network network="whatsapp" class="whatsapp">
                  <i class="fab fa-whatsapp-square"></i>
                </network>
            </div>
          </social-sharing>
         </div>
        </article>

      </section>
    </b-container>

  </div>
</template>
<script type="text/javascript">
import HeaderOfPage from '../global/HeaderOfPage'
export default {
  name:'SinglePlacePage',
  components: {
    HeaderOfPage,

  },
  data() {
    return {

    }
  }
}
</script>
